exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.error__container[data-v-77b540cc]{margin-top:8px;width:100%;padding:8px;background-color:#eee6fb;border-radius:4px;border:1px solid #5807d9\n}\n@media (min-width: 768px){\n.error__container[data-v-77b540cc]{margin-top:6px;width:75%\n}\n}\n.error__alert[data-v-77b540cc]{color:#5807d9;font-size:14px\n}\n.error__alert span[data-v-77b540cc]{font-weight:bold\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-77b540cc","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/online-service-booking/components/NonFranchiseVehicleError.vue
// module id = Jcuq
// module chunks = 20